import { toast } from "react-toastify";

import toastr from 'COMPONENTS/ShowTostr/ShowTostr';
import { socketMessage } from "WEBSOCKET/constants";
import {
  ACTIONS, USER_ROLES, SESSION_STATUS, TOAST_ID, SPEED_TEST_RESULT,
  SPEED_TEST_TOAST_OPTION,
} from "UTILS/Constants";
import { wsocket } from "WEBSOCKET/wsocket";
import * as log from "loglevel";
import { customerCoBrowseAction } from "CONFIG/ActionFactory";
import { getMessage } from "CONFIG/i18n";
import { postMesageToCoBrowseIframeUtility } from "UTILS/Utility";

log.setLevel("info");

export const handleMessage = (data, store) => {
  const reducerData = store.getState();
  const showCustomerCoBrowse = reducerData.CustomerCoBrowseReducer.showCustomerCoBrowse;
  const coBrowseBaseUrl = reducerData.CustomerCoBrowseReducer.coBrowseBaseUrl;
  const organiser = reducerData.RoomMetaDataReducer.roomMetaData.organiser;
  const presenterId = reducerData.RoomMetaDataReducer.roomMetaData.presenterId;
  const uniqueId = reducerData.SessionReducer.uniqueId;
  const token = reducerData.SessionReducer.sessionDetails.token;

  switch (data.action) {
    case socketMessage.subCategories.PARTICIPANT._PARTICIPANT_ARRIVED:
      store.dispatch({
        type: ACTIONS.UPDATE_PARTICIPANTS,
        participant: data.participant
      });

      // Show speed test toast to agent only.
      if (organiser === uniqueId && data.participant.speedTest) {
        const { userName } = data.participant;
        const { result, download, upload } = data.participant.speedTest;
        if (result === -1) {
          // speed test error
          const resultMessage = getMessage("SPEED_TEST_FAILURE_MESSAGE", { userName });
          // Hide this toastr for now
          // toastr.error(resultMessage, SPEED_TEST_TOAST_OPTION);
        } else {
          const status = getMessage(Object.keys(SPEED_TEST_RESULT).find((key) => {
            return (SPEED_TEST_RESULT[key] === result);
          }));
          let messageList = [];
          messageList.push(getMessage("USER_CONNECTION_STATUS", { userName, status}));
          messageList.push(`${getMessage("DOWNLOAD")}: ${download} Mbps`);
          messageList.push(`${getMessage("UPLOAD")}: ${upload} Mbps`);
          // Hide this toastr for now
          // toastr.infoMassageList(messageList, SPEED_TEST_TOAST_OPTION);
        }
      }
      if (
        organiser === uniqueId
        && data.participant.role === USER_ROLES.USER
        && data.participant.terminalInfo
      ) {
        const { userName, terminalInfo } = data.participant;
        const splitTerminInfo = terminalInfo.split(":");
        let messageList = [];
        messageList.push(getMessage("USER_TERMINAL_INFO", { userName }));
        messageList.push(`　${splitTerminInfo[0]}`);
        messageList.push(`　${splitTerminInfo[1]}`);
        toastr.infoMassageList(messageList, SPEED_TEST_TOAST_OPTION);
      }
      break;

    case socketMessage.subCategories.PARTICIPANT._EVICT_PARTICIPANT:
      // Post End_session_without_confirmation from user's end when agent evicts user/participant from session
      if (showCustomerCoBrowse) {
        postMesageToCoBrowseIframeUtility(token, coBrowseBaseUrl);
        setTimeout(() => {
          if (presenterId == uniqueId) {
            customerCoBrowseAction.endCustomerCoBrowse();
          } else {
            customerCoBrowseAction.leaveCustomerCoBrowse(uniqueId);
          }
          store.dispatch({
            type: ACTIONS.SET_USER_EVICTED_FLAG,
            isUserEvicted: true
          });
        }, 500);
      } else {
        store.dispatch({
          type: ACTIONS.SET_USER_EVICTED_FLAG,
          isUserEvicted: true
        });
      }
      break;

    case socketMessage.subCategories.PARTICIPANT._LEFT:
      //if agent left the session
      //Post End_session_without_confirmation from presenter's end once agent left session
      if (data.participant.role === USER_ROLES.AGENT && showCustomerCoBrowse && presenterId == uniqueId){
        postMesageToCoBrowseIframeUtility(token, coBrowseBaseUrl);
        setTimeout(() => {
          customerCoBrowseAction.endCustomerCoBrowse();
        }, 500);
      }
      if (organiser === uniqueId && data.participant.role !== USER_ROLES.AGENT) {
        toast.dismiss(TOAST_ID.ADMIT + data.participant.uniqueId);
      }
      store.dispatch({
        type: ACTIONS.LOCATION.STOP_LOCATION_SHARE,
        participant: data.participant.uniqueId
      });

      // participantに退出理由を追加してdispatchする
      const participantWithReason = {
        ...data.participant,
        leftReason: data.leftReason,
      };
      store.dispatch({
        type: ACTIONS.DELETE_PARTICIPANT,
        participant: participantWithReason,
      });

      // Evicted participants details should be set before delete participant
      if(data.isParticipantEvicted === true) {
        store.dispatch({
          type: ACTIONS.SET_EVICTED_PARTICIPANT_DETAILS,
          evictedParticipantDetails: {
            evictedParticipantName: data.participant.userName,
            uniqueId: data.participant.uniqueId
          }
        });
      }

      if (
        data.participant.uniqueId &&
        wsocket.audioAndVideoRtcPeer[data.participant.uniqueId] !== undefined
      ) {
        Object.keys(wsocket.audioAndVideoRtcPeer[data.participant.uniqueId]).map((key) => {
          wsocket.audioAndVideoRtcPeer[data.participant.uniqueId][key].dispose();
        });
        wsocket.audioAndVideoRtcPeer[data.participant.uniqueId] = undefined;
      }

      if (data.participant.role === USER_ROLES.AGENT) {
        store.dispatch({
          type: ACTIONS.SET_SESSION_STATUS,
          sessionStatus: SESSION_STATUS.CLOSING
        });
      }
      let state = store.getState();
      if(state.SessionReducer.snapshoteeId === data.participant.uniqueId
        && state.ParticipantReducer.participants
        && state.ParticipantReducer.participants.length < 2){
        store.dispatch({
          type:ACTIONS.SNAPSHOT.SHOW_SNAPSHOT,
          value: false
        });
      }
      break;

    case socketMessage.subCategories.PARTICIPANT._UPDATE_SPEED_TEST:
      store.dispatch({
        type: ACTIONS.UPDATE_PARTICIPANT_SPEED_TEST_RESULT,
        speedTestParticipantId: data.remoteId,
        speedTest: data.speedTest,
      });
      store.dispatch({
        type: ACTIONS.SAVE_SPEED_TEST_PARTICIPANT_ID,
        speedTestParticipantId: null,
        speedTestParticipantName: null,
        speedTestDisconnectUserName: null,
      });

      if (data.remoteId !== organiser) {
        const { result } = data.speedTest;
        const userName = data.name;
        if (result === -1) {
          // speed test error
          if (
            organiser === uniqueId
            || data.remoteId === uniqueId
          ) {
            const resultMessage = getMessage("SPEED_TEST_FAILURE_MESSAGE", {userName});
            toastr.error(resultMessage, SPEED_TEST_TOAST_OPTION);
          }
        } else {
          const status = result !== undefined && 
            getMessage(Object.keys(SPEED_TEST_RESULT).find((key) => {
              return (SPEED_TEST_RESULT[key] === result);
            }));
          if (data.remoteId === uniqueId) {
            const resultMessage = `${getMessage("USER_CONNECTION_STATUS", {userName, status})}`;
            toastr.info(resultMessage, SPEED_TEST_TOAST_OPTION);
          } else if (organiser === uniqueId ) {
            const { download, upload } = data.speedTest;
            let messageList = [];
            messageList.push(getMessage("USER_CONNECTION_STATUS", { userName, status}));
            messageList.push(`${getMessage("DOWNLOAD")}: ${download} Mbps`);
            messageList.push(`${getMessage("UPLOAD")}: ${upload} Mbps`);
            toastr.infoMassageList(messageList, SPEED_TEST_TOAST_OPTION);
          }
        }
      }
      break;

    default:
      break;
  }
};
